import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { setNavItem } from "../../../utils/localStorage";
import "./TermsAndConditions.scss";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavItem(null);
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="terms">
      <button
        type="button"
        className="terms-back font-cairo-medium"
        onClick={handleBack}
      >
        <ArrowLeftOutlined />
        <span>Back</span>
      </button>

      <h1 className="terms-title font-cairo-extrabold">
        Champion's Choice — Terms of Participation and Game Rules
      </h1>
      <p className="terms-updated font-cairo-bold">
        Last updated: 17 August 2026
      </p>

      <h2 className="terms-heading font-cairo-bold">1. About these terms</h2>
      <p className="font-cairo-normal">
        1.1. Champion's Choice is a game provided by Champion's Choice SAL, a
        company registered in Lebanon (commercial register no. 403604), with
        its head office in Achrafieh, Beirut, Lebanon ("Champion's Choice",
        "we", "us", "our").
      </p>
      <p className="font-cairo-normal">
        1.2. Champion's Choice is offered to you through the BetArabia
        platform. These terms set out the rules of the game and the
        conditions of your participation.
      </p>
      <p className="font-cairo-normal">
        1.3. Your account, your funds, and your personal information are
        managed by BetArabia, not by us. Your use of the BetArabia platform is
        governed by BetArabia's own terms and conditions. If there is a
        conflict between BetArabia's terms and these terms, BetArabia's terms
        prevail in all matters relating to your account, funds, identity, and
        eligibility.
      </p>
      <p className="font-cairo-normal">
        1.4. By joining a Champion's Choice game, you accept these terms and
        the Game Rules in the Appendices below.
      </p>

      <h2 className="terms-heading font-cairo-bold">
        2. Your account and your information
      </h2>
      <p className="font-cairo-normal">
        2.1. You do not register with Champion's Choice. You access the game
        through your BetArabia account.
      </p>
      <p className="font-cairo-normal">
        2.2. We do not collect or hold your name, email address, or other
        personal details. We receive only a customer identification number
        from BetArabia. This number allows us to record your entries,
        selections, and results.
      </p>
      <p className="font-cairo-normal">
        2.3. All deposits, entry payments, and prize payments are processed
        through your BetArabia account.
      </p>

      <h2 className="terms-heading font-cairo-bold">3. Eligibility</h2>
      <p className="font-cairo-normal">
        3.1. You must be 21 years of age or older to play Champion's Choice.
      </p>
      <p className="font-cairo-normal">
        3.2. You must hold a valid BetArabia account in good standing and
        meet all of BetArabia's eligibility requirements.
      </p>
      <p className="font-cairo-normal">
        3.3. Underage gambling is a criminal offence. If we or BetArabia
        discover that you do not meet the eligibility requirements, your
        entries may be cancelled and your winnings may be withheld.
      </p>

      <h2 className="terms-heading font-cairo-bold">
        4. Entries and payments
      </h2>
      <p className="font-cairo-normal">
        4.1. All entry fees and prizes are in United States Dollars ($).
      </p>
      <p className="font-cairo-normal">
        4.2. The cost per entry is the same for all participants and for all
        entries within each game.
      </p>
      <p className="font-cairo-normal">
        4.3. Once you enter a game and make your first team selection, your
        entry is final. You cannot withdraw from a game, cancel your entry,
        or receive a refund of your entry fee.
      </p>
      <p className="font-cairo-normal">
        4.4. You may add more entries and change your team selections only as
        allowed by the Game Rules and before the advertised deadlines.
      </p>
      <p className="font-cairo-normal">
        4.5. Champion's Choice reserves the right to retain a percentage of
        the prize pot as commission fees.
      </p>

      <h2 className="terms-heading font-cairo-bold">5. Fair play</h2>
      <p className="font-cairo-normal">
        5.1. Entries must be for your own benefit only. You must play
        personally, through the interfaces provided.
      </p>
      <p className="font-cairo-normal">
        5.2. The following are strictly prohibited: fraud; cheating;
        collusion with other participants; use of multiple accounts; use of
        bots, automated software, or player assistance tools; exploiting bugs
        or loopholes; match rigging; and betting on fixed events.
      </p>
      <p className="font-cairo-normal">
        5.3. We monitor gameplay for suspicious activity. If we reasonably
        believe you have broken these rules, we may cancel your entries,
        withhold winnings, and report the matter to BetArabia and to the
        appropriate authorities.
      </p>

      <h2 className="terms-heading font-cairo-bold">6. Game information</h2>
      <p className="font-cairo-normal">
        6.1. Fixtures, results, statistics, and other sports data are
        provided by third parties. This information is provided for your
        convenience only. We do not guarantee that it is accurate, complete,
        or up to date.
      </p>
      <p className="font-cairo-normal">
        6.2. Official results used to settle a game round are final once the
        round is settled.
      </p>
      <p className="font-cairo-normal">
        6.3. Game information is for your personal use only. You may not
        distribute it or use it commercially.
      </p>

      <h2 className="terms-heading font-cairo-bold">
        7. Errors and events outside our control
      </h2>
      <p className="font-cairo-normal">
        7.1. We work to keep the game running smoothly, but we cannot promise
        that it will always be free of errors or interruptions.
      </p>
      <p className="font-cairo-normal">
        7.2. We are not responsible for events outside our reasonable
        control. These include, for example, network failures, failures of
        third-party systems, changes to fixture schedules, or the
        postponement, abandonment, or cancellation of sporting events.
      </p>
      <p className="font-cairo-normal">
        7.3. If an error, a technical fault, or an event outside our control
        affects a game or a round, we may declare the affected entries,
        round, or game void. Where a game is declared void, entry fees will
        be returned to participants through their BetArabia accounts.
      </p>

      <h2 className="terms-heading font-cairo-bold">8. Liability</h2>
      <p className="font-cairo-normal">
        8.1. Nothing in these terms excludes or limits any liability that
        cannot be excluded or limited under applicable law.
      </p>
      <p className="font-cairo-normal">
        8.2. Subject to clause 8.1, we are not liable for indirect or
        consequential losses, and our total liability to you in connection
        with any game is limited to the entry fees you paid for that game.
      </p>

      <h2 className="terms-heading font-cairo-bold">
        9. Intellectual property
      </h2>
      <p className="font-cairo-normal">
        9.1. All intellectual property in the Champion's Choice game,
        including its software, design, graphics, and content, belongs to us
        or to our licensors. You may not copy, modify, reverse engineer, or
        create derivative works from any part of the game.
      </p>

      <h2 className="terms-heading font-cairo-bold">10. Complaints</h2>
      <p className="font-cairo-normal">
        10.1. If you have a question, concern, or complaint about Champion's
        Choice, please contact BetArabia customer support at{" "}
        <a href="mailto:support@betarabia.com">support@betarabia.com</a>.
      </p>
      <p className="font-cairo-normal">
        10.2. BetArabia will handle your query and will contact us where
        needed.
      </p>
      <p className="font-cairo-normal">
        10.3. In the event of a dispute about entries, selections, or
        results, the official game records will be used to resolve the
        dispute.
      </p>

      <h2 className="terms-heading font-cairo-bold">
        11. Changes to these terms
      </h2>
      <p className="font-cairo-normal">
        11.1. We may update these terms from time to time, including to
        reflect changes in the games we offer or in legal or regulatory
        requirements. The latest version will always be available on this
        page, together with the date of the last update. Changes apply to
        games that start after the change is published.
      </p>

      <h2 className="terms-heading font-cairo-bold">12. Governing law</h2>
      <p className="font-cairo-normal">
        12.1. These terms are governed by the laws of Lebanon.
      </p>

      <h1 className="terms-title font-cairo-extrabold terms-appendix-title">
        Appendix 1 — Game Rules
      </h1>

      <h2 className="terms-heading font-cairo-bold">
        A. Standard football games
      </h2>
      <ol className="terms-list font-cairo-normal">
        <li>
          Choose a game to join. The cost per entry is the same for all
          participants and for all entries within each game.
        </li>
        <li>
          For each entry, you must select one team from the round's fixture
          list to WIN their fixture.
        </li>
        <li>
          If your selected team wins, your entry goes through to the next
          round. If your selected team draws or loses, your entry is
          eliminated from the game.
        </li>
        <li>
          If your entry goes through, you must select a team again from the
          next round's fixtures, before the advertised deadline. A team that
          you have already selected with that entry cannot be selected again
          by that entry in the same game.
        </li>
        <li>
          You may purchase up to three (3) entries per game. Each entry is
          treated as an independent entry, with its own selections and its
          own list of used teams.
        </li>
        <li>
          If you purchase one entry before the start of a game, you may add
          one or two more entries (up to the maximum of three) before the
          advertised deadline of the first round.
        </li>
        <li>
          Selections must be made before the advertised deadline. If you do
          not make a selection before the deadline, your entry will be given
          the lowest-placed team in the league table that is still available
          to that entry. This is the "default selection".
        </li>
        <li>
          The deadline for selections is two (2) hours before the start of
          the first fixture of each round. We may change the deadline in
          exceptional circumstances, for example if fixture schedules change.
          Any change will be communicated. If you miss an adjusted deadline,
          rule 7 applies.
        </li>
        <li>
          All selections remain hidden from other participants until the
          round's deadline has passed. After the deadline, all selections
          for that round become visible to all participants in the game.
        </li>
        <li>
          You may change a selection at any time before the deadline. If you
          made a selection before the deadline and the fixture is then
          postponed, and you did not change your selection, rule 7 applies.
        </li>
        <li>
          When 10% or fewer of the total participants remain in a game, the
          remaining participants share an equal split of 10% of the prize
          pot. The game then continues, and the final winner or winners
          receive the rest of the pot.
        </li>
        <li>
          The winner is the last participant standing. If the last remaining
          participants are all eliminated in the same round, the remaining
          pot is split equally between them.
        </li>
        <li>
          If all remaining participants reach a round where they have no
          teams left to select, the game ends and the remaining pot is split
          equally between them.
        </li>
        <li>
          If all participants are eliminated in the first round of a game,
          that round is void. All participants go through to round 2, and
          rule 4 applies as if no teams have been used.
        </li>
        <li>
          If a game ends in a week where more than 10% of participants are
          still standing, the prize pot is split equally between them all.
        </li>
        <li>
          A round is valid if it contains at least seven (7) fixtures of the
          competition. If there are fewer than seven fixtures, the round is
          void and is postponed to the following match week. In a void
          round, selections are not counted as "used" under rule 4, and
          those teams become available again in later rounds.
        </li>
        <li>
          A fixture played out of sequence, because of an earlier
          postponement or rescheduling, is not included in the fixture list
          of a round.
        </li>
        <li>
          If a game has not finished by the end of the league season, the
          remaining pot is split equally between the last standing
          participants.
        </li>
        <li>
          Champion's Choice reserves the right to retain a percentage of the
          pot as commission fees.
        </li>
      </ol>

      <h2 className="terms-heading font-cairo-bold">
        B. Games with a guaranteed prize pot
      </h2>
      <p className="font-cairo-normal">
        Some games may be advertised with a guaranteed prize pot. In these
        games, the same rules apply as in Appendix 1A, with the following
        addition:
      </p>
      <ol className="terms-list font-cairo-normal">
        <li>
          The advertised guaranteed prize pot is the smallest, minimum total
          pot that will be paid out in that game.
        </li>
        <li>
          If the total entry fees collected produce a pot smaller than the
          advertised minimum, Champion's Choice will increase the pot to the
          advertised minimum.
        </li>
        <li>
          If the total entry fees collected produce a pot larger than the
          advertised minimum, the larger pot applies.
        </li>
      </ol>

      <h2 className="terms-heading font-cairo-bold">
        C. Turbo mode games (where applicable)
      </h2>
      <p className="font-cairo-normal">
        Turbo mode applies to football turbo games and to NBA games, where
        these are offered. In turbo mode, the rules in Appendix 1A apply,
        with the following exceptions:
      </p>
      <ol className="terms-list font-cairo-normal">
        <li>
          A round is one game day with at least one fixture. For the NBA, a
          round is likely to take place every day during the regular season.
        </li>
        <li>
          For each entry, you must select one team from the round's fixture
          list ("game day") to WIN their fixture.
        </li>
        <li>You may purchase only one (1) entry per game.</li>
        <li>
          Once you have purchased your entry and made your selection, you
          may edit the selection before the advertised deadline.
        </li>
        <li>
          A round is valid if it contains at least one (1) fixture of the
          competition. Otherwise the round is void and is postponed to the
          following match day. In a void round, selections are not counted
          as "used", and those teams become available again in later
          rounds.
        </li>
        <li>
          Champion's Choice reserves the right to retain a percentage of the
          pot as commission fees.
        </li>
      </ol>

      <button
        type="button"
        className="terms-back terms-back-bottom font-cairo-medium"
        onClick={handleBack}
      >
        <ArrowLeftOutlined />
        <span>Back</span>
      </button>
    </div>
  );
};

export default TermsAndConditions;
